
export interface RoleBasedCost {
  category: string;
  amount: number;
  description: string;
  details: string;
}

export const calculateRoleBasedCosts = (resourceAssignments: any[]): RoleBasedCost[] => {
  console.log('🧮 ROLE COST CALC: Starting role-based cost calculations:', {
    totalAssignments: resourceAssignments.length,
    sampleAssignment: resourceAssignments[0]
  });

  // Initialize role cost accumulators
  const roleCosts = {
    'project-director': 0,
    'project-manager': 0,
    'team-lead': 0,
    'team-member': 0
  };

  // Calculate costs for each assignment using allocation_hrs directly
  resourceAssignments.forEach(assignment => {
    const rate = assignment.rate || 0;
    const duration = assignment.duration || 0;
    const roleType = assignment.role_type;
    const allocationHours = parseFloat(assignment.allocation_hrs) || 0;
    const allocatedPercentage = assignment.allocated_percentage || 100;
    const resourceCost = rate * (allocatedPercentage / 100) * duration * allocationHours;

    // Aggregate by exact role_type from database
    if (roleType && roleCosts.hasOwnProperty(roleType)) {
      roleCosts[roleType] += resourceCost;
    }

    console.log('💰 ROLE COST DETAIL:', {
      name: assignment.name,
      roleType,
      rate,
      allocationHours,
      duration,
      resourceCost,
      currentTotal: roleCosts[roleType] || 0
    });
  });

  console.log('📊 ROLE COST TOTALS:', roleCosts);

  // Convert to the expected format
  const breakdown: RoleBasedCost[] = [
    {
      category: 'Directors',
      amount: Math.round(roleCosts['project-director']),
      description: 'Project Directors',
      details: 'Senior leadership and strategic oversight'
    },
    {
      category: 'Managers',
      amount: Math.round(roleCosts['project-manager']),
      description: 'Project Managers',
      details: 'Project management and coordination'
    },
    {
      category: 'Team Leads',
      amount: Math.round(roleCosts['team-lead']),
      description: 'Team Leads',
      details: 'Technical leadership and team coordination'
    },
    {
      category: 'Team Members',
      amount: Math.round(roleCosts['team-member']),
      description: 'Team Members',
      details: 'Implementation and development work'
    }
  ];

  console.log('✅ ROLE BREAKDOWN FINAL:', breakdown);

  return breakdown;
};
